import type { ColumnType } from 'antd/es/table';
import { CryptoFlag } from 'shared/src/CryptoFlag';
import { CryptoNetworkIcon } from 'shared/src/CryptoNetworkIcon';

import type { GetCryptoDeposits200DataItem } from 'api';

import { FormattedDateTime } from '@molecules/FormattedDateTime';

import { depositStatusColor } from './DepositsTable';

import { StatusBadge } from '../shared/StatusBadge';

const colSpacing = {
  onHeaderCell: () => ({ style: { padding: '8px 16px' } }),
  onCell: () => ({ style: { padding: '8px 16px' } })
};

export const depositColumns: ColumnType<GetCryptoDeposits200DataItem>[] = [
  {
    ...colSpacing,
    key: 'asset',
    width: 5,
    render: (_, record) => (
      <div className="relative inline-flex">
        <CryptoFlag cryptoCode={record.asset} className="size-6" />
        <CryptoNetworkIcon
          network={record.network ?? ''}
          className="absolute -bottom-0.5 -right-0.5 size-3"
        />
      </div>
    )
  },
  {
    ...colSpacing,
    title: 'Amount',
    align: 'right',
    render: (_, record) => (
      <p className="font-medium">
        {record.formatted_amount
          ? `${record.formatted_amount} ${record.asset}`
          : '-'}
      </p>
    )
  },
  {
    ...colSpacing,
    title: 'Date',
    dataIndex: 'layer1_created_at',
    key: 'layer1_created_at',
    align: 'right',
    render: (value: string) => <FormattedDateTime value={value} format="cet" />
  },
  {
    ...colSpacing,
    title: 'Status',
    dataIndex: 'status',
    align: 'right',
    key: 'status',
    render: (status: string) => (
      <StatusBadge color={depositStatusColor?.[status]} statusText={status} />
    )
  }
];
